export function minLength(value) {
  let error;
  if (!value) {
    error = "Campo requerido";
  } else if (value.length < 6) {
    error = "Tamanho minimo inválido";
  }
  return error;
}
export const validPassword = (value) => {
  const regex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  )
  return regex.test(value);;
};
export const number = value =>
  value && isNaN(Number(value)) ? "Deve ser um número" : undefined;
export const required = value => {
  if (Array.isArray(value)) {
    if (value.length) return null;
    return "Selecione uma opção";
  }
  return value ? null : "Campo deve ser informado";
};
export const isAtimer = value => {
  if (value) {
    const timer = value.split(":");

    if (timer.length !== 3) {
      return "Tempo inválido";
    }
    return null;
  }

  return "Tempo inválido";
};

export const minValue = min => value =>
  value && value < 0 ? `Pontuação deve ser maior ou igual a ${min}` : undefined;
export const minValueMonth = value =>
  value > 12 ? `Valor deve ser menor que ${12}` : undefined;

export const minValue0 = minValue(0);
export const minValue1 = minValue(1);
export const minValue12 = minValueMonth(12);

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "E-mail inválido"
    : undefined;

export const tooYoung = value =>
  value && value < 13
    ? "You do not meet the minimum age requirement!"
    : undefined;
export const aol = value =>
  value && /.+@aol\.com/.test(value)
    ? "Really? You still use AOL for your email?"
    : undefined;

export const alphaNumeric = value =>
  value && /[^a-zA-Z\s]/i.test(value)
    ? "Use somente caracteres alfanuméricos"
    : undefined;

export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? "Invalid phone number, must be 10 digits"
    : undefined;

export const validDate = value =>
  value && /^(0?[1-9]|[12][0-9]|3[01])(0?[1-9]|1[012])\d{4}$/.test(value)
    ? "Data do aniversário inválida"
    : undefined;
